import axios from '../Backend';


export const blockWhatsappUser = async (chatId) => {
    const res = await axios.post('/chats/block-whatsapp-user', { chatId });
    return res.data;
}

export const fetchChatUpdatedCrmData = async (clientName, msgType) => {
    try {
        if (!clientName || !msgType) return console.log('fetchChatUpdatedCrmData :: some data is missed')

        axios.put('/fetchChatUpdatedCrmData', { clientName, msgType });

    } catch (e) {
        console.log('fetchChatUpdatedCrmData :: Error')
        console.log(JSON.stringify(e))
    }
}

